import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Loader from '../Loader/Loader';
const Button = ({ value, type = 'btn-primary', isLoader, onClick, disabled, style, icon }) => {
    return (_jsx("button", Object.assign({ style: style, className: `btn ${type} w-100`, disabled: disabled, onClick: onClick }, { children: isLoader ? (_jsx(Loader, { type: "text-light", size: true })) : (_jsxs(_Fragment, { children: [icon, " ", value] })) })));
};
export default Button;
